import { useMutation } from "@tanstack/react-query";
import Axios from "axios";

const useGuestsLetterPrinterMutation = (onSuccess) => {
  return useMutation({
    mutationFn: ({ guestId, isNewLetterPrinted, isLetterPrinted }) => {
      return Axios.patch(
        `${process.env.REACT_APP_BASE_URL}/guests/${guestId}/letter-printed`,
        JSON.stringify(
          isNewLetterPrinted !== undefined
            ? { isNewLetterPrinted }
            : { isLetterPrinted }
        ),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: localStorage.getItem("token"),
          },
        }
      );
    },
    onSuccess,
  });
};

export default useGuestsLetterPrinterMutation;
